module.exports = __webpack_public_path__ + "img/cover.7f9de50c.png";